import template from './companies-list.html';
import controller from './companies-list.controller';
import './companies-list.styl';

const companiesListComponent = {
  template,
  controller,
  controllerAs: 'companiesList',
  require: {
    app: '^^app'
  }
};

export default companiesListComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/companies/companies-list/companies-list.component.js
 **/